import React, { useState, useEffect } from "react";
import AppBody from "../../components/AppBody";
import { Link, useNavigate } from "react-router-dom";

const AssessmentTestPage = () => {
  const list = [
    { id: 1, question: "Which of the following statements should be used to obtain a remainder after dividing 3.14 by 2.1 ?", option1: "rem = 3.14 % 2.1;", option2: "rem = modf(3.14, 2.1);", option3: "rem = fmod(3.14, 2.1);", option4: "Remainder cannot be obtain in floating point division." },
    { id: 2, question: "What are the types of linkages?", option1: "Internal and External", option2: "External, Internal and None", option3: "External and None", option4: "Internal"},
    { id: 3, question: "Which of the following special symbol allowed in a variable name?", option1: "* (asterisk)", option2: "| (pipeline)", option3: "-(hyphen)", option4: "_(underscore)" }
   ];

  const [questions, setQuestions] = useState(list);

  const [currentQuestion, setCurrentQuestion] = useState(questions[0]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPrevious, setShowPrevious] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  let totalQuestion = questions.length - 1;
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const setCurrentOption = (data) => {
    let selectQues = { id: currentQuestion.id, ans: data };
    let totalSelectedQuestion = selectedQuestions.length;

    if (totalSelectedQuestion === 0) {
      setSelectedQuestions([...selectedQuestions, selectQues]);
    } else {
      const isFound = selectedQuestions.some((element) => {
        if (element.id === currentQuestion.id) {
          return true;
        }
        return false;
      });
      if (isFound) {
        const updateState = selectedQuestions.map((obj) => {
          if (obj.id === currentQuestion.id) {
            return { ...obj, ans: data };
          }
          return obj;
        });
        setSelectedQuestions([...updateState]);
      } else {
        setSelectedQuestions([...selectedQuestions, selectQues]);
      }
    }
  };

  const setQuestion = (ch) => {
    let fetchQuestionIndex;
    if (ch === 1) {
      // Preve
      if (currentIndex > 0) {
        fetchQuestionIndex = currentIndex - 1;
        if (fetchQuestionIndex === 0) {
          setShowPrevious(false);
        }
      }
    } else {
      if (currentIndex < totalQuestion) {
        // Next
        fetchQuestionIndex = currentIndex + 1;
        setShowPrevious(true);
      }
    }
    // Specific inxed record fetch
    let res = questions[fetchQuestionIndex];
    setCurrentQuestion(res);
    setCurrentIndex(fetchQuestionIndex);
  };

  const [timeRemaining, setTimeRemaining] = useState(30 * 60);

  useEffect(() => {
    const timer = setInterval(() => {
      if (timeRemaining > 0) {
        setTimeRemaining(timeRemaining - 1);
      } else {
        setLoading(true);
        // let data = {
        //   questions: selectedQuestions,
        //   email: email,
        //   mobile_no: mobile_no,
        // };
        // axios
        //   .post("http://beta.cg-it.in/api/submit-test", data)
        //   .then(() => {
        //     setLoading(false);
        //     navigate("/thank-you");
        //   })
        //   .catch((error) => console.log(error));
        clearInterval(timer);
        //navigate("/thank-you");
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [timeRemaining]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  let obj = {};
  if (questions.length > 0 && selectedQuestions.length > 0) {
    obj = selectedQuestions.find((o) => o.id === currentQuestion.id);
  }

  return (
    <AppBody
      loading={false}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link
                  to={"/training-syllabus/"}
                  className="d-inline-block mt-2"
                >
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Assessment
                </h4>
              </div>
              <div className="card-body  p-4 w-100 border-0 ">
                <div className="row">
                  <div className="col-lg-12 test-submit">
                    <span className="mt-2 text-white test-timer">
                      {formatTime(timeRemaining)}{" "}
                    </span>
                    <input
                      type="submit"
                      name="submit"
                      value="Submit"
                      className="btn-common px-5"
                    />
                  </div>
                  <div className="col-lg-12">
                    {currentQuestion && currentQuestion.id && (
                      <div className="test-div">
                        <span className="assessment-q">
                          {currentIndex + 1} . {currentQuestion.question}
                        </span>{" "}
                        <br />
                        <div className="opt-group">
                          <input
                            type="radio"
                            className="q-radio"
                            name={"option"}
                            checked={
                              obj && obj.ans === currentQuestion.option1
                                ? true
                                : false
                            }
                            value={currentQuestion && currentQuestion.option1}
                            onChange={(e) => setCurrentOption(e.target.value)}
                          />
                          <label className={"q-option"}>
                            {currentQuestion.option1}
                          </label>{" "}
                          <br />
                          <input
                            type="radio"
                            className="q-radio"
                            name={"option"}
                            checked={
                              obj && obj.ans === currentQuestion.option2
                                ? true
                                : false
                            }
                            value={currentQuestion && currentQuestion.option2}
                            onChange={(e) => setCurrentOption(e.target.value)}
                          />
                          <label className={"q-option"}>
                            {currentQuestion.option2}
                          </label>{" "}
                          <br />
                          <input
                            type="radio"
                            className="q-radio"
                            name={"option"}
                            checked={
                              obj && obj.ans === currentQuestion.option3
                                ? true
                                : false
                            }
                            value={currentQuestion && currentQuestion.option3}
                            onChange={(e) => setCurrentOption(e.target.value)}
                          />
                          <label className={"q-option"}>
                            {currentQuestion.option3}
                          </label>{" "}
                          <br />
                          <input
                            type="radio"
                            className="q-radio"
                            name={"option"}
                            checked={
                              obj && obj.ans === currentQuestion.option4
                                ? true
                                : false
                            }
                            value={currentQuestion && currentQuestion.option4}
                            onChange={(e) => setCurrentOption(e.target.value)}
                          />
                          <label className={"q-option"}>
                            {currentQuestion.option4}
                          </label>{" "}
                          <br />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="col-lg-12 test-submit">
                    {showPrevious && (
                      <input
                        type="button"
                        name="submit"
                        value="Previous"
                        className="btn-common px-5"
                        readOnly={true}
                        onClick={() => setQuestion(1)}
                      />
                    )}

                    <button
                      type="button"
                      name="submit"
                      className="btn-common px-5"
                      disabled={currentIndex === totalQuestion ? true : false}
                      onClick={() => setQuestion(2)}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AssessmentTestPage;
